import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import { type FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import FloatingLabelInput from '../floating-label-input'

type DiscountCodeFormProps = {
    initialCode: string
    requestInProgress: boolean
    errorMessage: string | null
    onSubmit: (discountCode: string) => Promise<void>
    onChangeStart: () => void
}

export default function DiscountCodeForm({
    initialCode,
    requestInProgress,
    errorMessage,
    onSubmit,
    onChangeStart,
}: DiscountCodeFormProps) {
    const { t } = useTranslation()
    const [discountCode, setDiscountCode] = useState(initialCode)

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        await onSubmit(discountCode)
    }

    return (
        <form onSubmit={handleSubmit} style={{ marginBottom: 0 }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                pr: 1,
            }}>
                <Box flexGrow={1}>
                    <FloatingLabelInput
                        label={t('checkout.discountCode.label')}
                        value={discountCode}
                        onChange={event => {
                            onChangeStart()
                            setDiscountCode(event.target.value)
                        }}
                        error={!!errorMessage}
                    />
                </Box>
                <Button
                    variant="soft"
                    type="submit"
                    disabled={requestInProgress || !discountCode.trim()}
                    sx={{
                        color: 'black',
                        backgroundColor: 'var(--joy-palette-neutral-50)',
                        '&:hover': {
                            color: 'black',
                            backgroundColor: 'var(--joy-palette-neutral-100)',
                        },
                        borderRadius: 7,
                        border: '1px solid var(--joy-palette-neutral-200)',
                    }}
                >
                    {t('checkout.discountCode.apply')}
                </Button>
            </Box>
            {errorMessage ? (
                <Typography level="body-xs" color="danger" sx={{ mt: 0.5 }}>
                    {errorMessage}
                </Typography>
            ) : null}
        </form>
    )
}
